export const UI_ENTITY_ITEM_ACTION = {
    create: 'create',
    update: 'update',
    delete: 'delete',
    deleteAsync: 'deleteAsync',
    changeStatus: 'changeStatus',
}
